<template>
  <b-modal
    ok-title="Enviar"
    id="modal-1"
    modal
    :title="$ml.get('activeDoubleCampaign')"
  >
    <div class="d-flex align-items-center mb-4">
      <div class="custom-control custom-checkbox">
        <input
          type="checkbox"
          class="custom-control-input"
          v-model="bounties"
        />
        <label class="custom-control-label" v-text="$ml.get('doubleBounties')"
          >Bounties</label
        >
      </div>
      <div class="custom-control custom-checkbox ml-4">
        <input type="checkbox" class="custom-control-input" v-model="score" />
        <label class="custom-control-label" v-text="$ml.get('doubleScore')"
          >Pontuação</label
        >
      </div>
    </div>
    <div class="d-flex">
      <div class="col-12 pr-2 input-group">
        <b-form-datepicker
          class="datepicker m-0 p-0"
          label-help=""
          :date-format-options="{
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
          }"
          :locale="$ml.get('ln')"
          today-button
          reset-button
          close-button
          :label-today-button="$ml.get('today')"
          :label-reset-button="$ml.get('reset')"
          :label-close-button="$ml.get('exit')"
          :min="minDateInitialCampaign"
          v-model="initialDate"
          :placeholder="$ml.get('start')"
        >
        </b-form-datepicker>
      </div>
      <div class="col-12 input-group">
        <b-form-datepicker
          class="datepicker m-0 p-0"
          label-help=""
          :date-format-options="{
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
          }"
          :locale="$ml.get('ln')"
          today-button
          reset-button
          close-button
          :label-today-button="$ml.get('today')"
          :label-reset-button="$ml.get('reset')"
          :label-close-button="$ml.get('exit')"
          :min="initialDate"
          :max="maxDate"
          v-model="finalDate"
          :disabled="initialDate == null"
          :placeholder="$ml.get('end')"
        >
        </b-form-datepicker>
      </div>
    </div>

    <div>
      <div class="header-severity-list">
        <div class="flex-1">
          <span v-text="$ml.get('severity')">Severidade</span>
        </div>
        <div class="flex-1 text-center">
          <span v-text="$ml.get('current')">Atual</span>
        </div>
        <div class="flex-1 text-center">
          <span v-text="$ml.get('end')">Final</span>
        </div>
      </div>
      <ListBounty
        severity="low"
        :bounty="bounty_low"
        :double-bounty="doubleBountyLow"
      />
      <ListBounty
        severity="medium"
        :bounty="bounty_medium"
        :double-bounty="doubleBountyMedium"
      />
      <ListBounty
        severity="high"
        :bounty="bounty_high"
        :double-bounty="doubleBountyHigh"
      />
      <ListBounty
        severity="critical"
        :bounty="bounty_critical"
        :double-bounty="doubleBountyCritical"
      />
    </div>

    <div class="custom-control custom-checkbox mt-3">
      <input
        type="checkbox"
        class="custom-control-input"
        v-model="confirmDoubleReward"
        style="height: 15px; width: 15px"
      />
      <label
        class="custom-control-label"
        v-text="$ml.get('doubleCheckCampaign')"
        >Estou ciente das alterações do valor atual das recompensas.</label
      >
    </div>
    <template #modal-footer="{ ok, cancel }">
      <b-button
        :disabled="!confirmDoubleReward"
        style="background: #730ba9"
        size="sm"
        @click="ok(), createDoubleCampaing()"
      >
        {{ $ml.get("btnRegister") }}
      </b-button>
      <b-button
        class="float-right btn-outline-extra"
        size="sm"
        variant="primary"
        @click="cancel()"
      >
        {{ $ml.get("cancel") }}
      </b-button>
    </template>
  </b-modal>
</template>
<script>
import moment from "moment";
import Swal from "sweetalert2";
import ProgramService from "../../../services/program.service";
import ListBounty from "./ListBounty.vue";
export default {
  name: "ModalDoubleReward",
  props: {
    bounty_low: {
      type: Number,
      required: false,
      default: 0,
    },
    bounty_medium: {
      type: Number,
      required: false,
      default: 0,
    },
    bounty_high: {
      type: Number,
      required: false,
      default: 0,
    },
    bounty_critical: {
      type: Number,
      required: false,
      default: 0,
    },
    changeProgram: {
      type: Function,
      requerid: false,
      default: () => {},
    },
  },

  components: {
    ListBounty,
  },

  data() {
    return {
      id: "",
      double_reward: 2,
      bounties: false,
      score: false,
      initialDate: null,
      finalDate: null,
      confirmDoubleReward: false,
      maxDate: null,
    };
  },

  created() {
    this.id = this.$route.fullPath.split("?")[1];
  },

  watch: {
    // Define a data máxima após a data inicial ser selecionada
    initialDate(newValue) {
      const maxDate = new Date(newValue);
      maxDate.setDate(maxDate.getDate() + 30);
      this.maxDate = maxDate.toISOString().slice(0, 10);
    },
  },

  computed: {
    doubleBountyLow() {
      if(this.bounties){
        return this.bounty_low * this.double_reward;
      }
      return this.bounty_low 
    },
    doubleBountyMedium() {
      if(this.bounties){
        return this.bounty_medium * this.double_reward;
      }
      return this.bounty_medium 
    },
    doubleBountyHigh() {
      if(this.bounties){
        return this.bounty_high * this.double_reward;
      }
      return this.bounty_high 
    },
    doubleBountyCritical() {
      if(this.bounties){
        return this.bounty_critical * this.double_reward;
      }
      return this.bounty_critical 
    },
    minDateInitialCampaign() {
      const now = moment();
      let today = moment(now, "DD/MM/YYYY").format("YYYY-MM-DD");
      return today;
    },
  },

  methods: {
    async createDoubleCampaing() {
      const self = this;

      if (this.initialDate == null || this.finalDate == null) {
        Swal.fire({
          icon: "info",
          title: "",
          text: self.$ml.get("invalidDateMessage"),
        });
        return;
      }

      if (this.bounties == false && this.score == false) {
        Swal.fire({
          icon: "info",
          title: "",
          text: self.$ml.get("warningBoutiesOrScore"),
        });
        return;
      }

      try {
        await ProgramService.postProgramCampaign(this.id, {
          offers_double_bounty: this.bounties == true ? "yes" : "no",
          offers_double_score: this.score == true ? "yes" : "no",
          campaign_initial_date: moment(this.initialDate).format(
            "YYYY-MM-DDTHH:mm:ss.SSS"
          ),
          campaign_final_date: moment(this.finalDate).format(
            "YYYY-MM-DDTHH:mm:ss.SSS"
          ),
        });

        Swal.fire({
          icon: "success",
          title: self.$ml.get("successfullyCreatedCampaign"),
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 5000,
        });

        this.changeProgram(this.$route.fullPath.split("?")[1]);
      } catch (error) {
        Swal.fire({
          icon: "info",
          title: "",
          text: self.$ml.get("registeredProgramWarning"),
        });
      }
    },
  },
};
</script>

<style scoped>
.header-severity-list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 12px 0px;
  padding: 4px;
  border: 1px solid #cccccc1a;
  background-color: #eef4f71a;
  border-radius: 6px;
  color: #6c757d;
  font-weight: 400;
  font-size: 14px;
}
.flex-1 {
  flex: 1;
}
</style>
